<template>
  <div class="DatePicker-legend DatePicker-legend--locked" />
  {{ t('ui.booking.search.datePicker.legend.locked', { date: unlockingDateFormatted }) }}
</template>

<script setup lang="ts">
import { useDateFormat } from '@cvo/ui/composables';
import { useI18n } from '@cvo/i18n/composables/useI18n';

const props = defineProps<{
  unlockingDate?: Date
}>();

const { t } = useI18n();

const unlockingDateFormatted = useDateFormat(() => props.unlockingDate);
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/layout';

@layer cvo-ui {
  .DatePicker-legend {
    @include layout.square(24px);
    display: inline-block;
    aspect-ratio: 1/1;
    &--locked {
      background-color: vars.$molecules-datepicker-base-visual-cue-locked-bg-color;
      border: 1px solid vars.$molecules-datepicker-base-visual-cue-locked-border-color;
      border-radius: vars.$border-radius-xs;
    }
  }
}
</style>